import { PivotTableProps } from 'components/pivot-table/PivotTable'
import {
  ExamesRelatorioGerencialExameSelectFieldDocument,
  OrigemRelatorioGerencialExameSelectFieldDocument,
} from 'graphql/hooks.generated'

import { KeyMapping, keyMappings } from '../common/keyMapping-relatorioGerencial'
import { VisibilidadeModeloPersonalizadoEnum } from '../components/modelo-personalizado/form/model-modeloPersonalizadoRelatorioGerencialForm'
import { RelatorioGerencialExamesModel } from './model-relatorioGerencialExames'

const exame: KeyMapping = {
  keyName: 'Exame',
  formatter: (s: string) => s,
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: ExamesRelatorioGerencialExameSelectFieldDocument,
  },
}

const origem: KeyMapping = {
  keyName: 'Origem',
  formatter: (s: string) => s,
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: OrigemRelatorioGerencialExameSelectFieldDocument,
  },
}

export const examesKeyMapping: PivotTableProps<RelatorioGerencialExamesModel>['keyMapping'] = new Map<
  keyof RelatorioGerencialExamesModel,
  KeyMapping
>([
  ['exame', exame],
  ['origem', origem],
  ['turno', keyMappings.turno],
  ['dia', keyMappings.dia],
  ['mes', keyMappings.mes],
  ['hora', keyMappings.hora],
  ['semana', keyMappings.semana],
  ['diaSemana', keyMappings.diaDaSemana],
  ['faixaEtaria', keyMappings.faixaEtaria],
  ['sexo', keyMappings.sexo],
  ['tipoAtendimento', keyMappings.tipoAtendimento],
  ['municipio', keyMappings.municipio],
  ['unidadeSaude', keyMappings.unidadeSaude],
  ['equipe', keyMappings.equipe],
  ['nomeProfissional', keyMappings.nomeProfissional],
  ['cbo', keyMappings.cbo],
  ['categoriaProfissional', keyMappings.categoriaProfissional],
  ['producoes', keyMappings.producoes],
  ['tipoConsulta', keyMappings.tipoConsulta],
])
